import React, { memo } from 'react'
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table'
import { Form, ButtonGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort, faArrowDownShortWide, faArrowUpWideShort, faImages, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import GlobalFilter from './globalFilter';
function CreateDashboard({ columns, data, editFun, dashboardName, handlemodal}) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        //rows,//use when we not use pagination
        page,//use when we use pagination
        prepareRow,
        //for globle filter
        state,
        preGlobalFilteredRows,
        setGlobalFilter,
        //for pagination
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable({ columns, data, }, useGlobalFilter, useSortBy, usePagination)

  
    return (
        <>
          <div className="row">
            <div className="col-sm-4 left-col">
              <GlobalFilter
                preGlobalFilteredRows={preGlobalFilteredRows}
                globalFilter={state.globalFilter}
                setGlobalFilter={setGlobalFilter}
              />
            </div>
            <div className="col-sm-8 right-col  text-end">
              <button className="btn-primary ml-3  add-btn" onClick={handlemodal}>
                <label className='mt-1' >Add</label>
                <i className='fa fa-plus-circle ms-2' />
              </button>
            </div>
          </div>
          <div className="table-responsive mt-3">
            <table {...getTableProps()} className="table">
              <thead className='table-secondary'>
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        style={{ whiteSpace: 'nowrap' }} className={column.render('Header') == "Action " ? "text-center" : ""}
                      >
                        {column.render('Header')} &nbsp;
                        <span>
                          {
                            column.render('Header') == "Action " ?
                              "" :
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? <FontAwesomeIcon icon={faArrowDownShortWide} />
                                    : <FontAwesomeIcon icon={faArrowUpWideShort} />
                                  : <FontAwesomeIcon icon={faSort} />}
                              </span>
                          }
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map(row => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => {
                        if (cell.column.id == "dashboardName") {
                          return (
                            <td
                              {...cell.getCellProps()}
                            >
                              <button type="button" className="btn btn-link" onClick={() => dashboardName(row.original.dashboard)}>View</button>
                            </td>
                          )
                        }
                        else if (cell.column.id == "action") {
                          return (
                            <td
                              {...cell.getCellProps()}
                              style={{ whiteSpace: 'nowrap' }} className="text-center"
                            >
                              <i onClick={() => editFun(row.original)} className='fa fa-pencil ' style={{ fontSize: '22px', color: '#0077B9' }}
                              ></i>
                            </td>
                          )
                        }
                        else {
                          return (
                            <td
                              {...cell.getCellProps()}
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              {cell.render('Cell')}
                            </td>
                          )
                        }
                        // }
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div className="row mt-2">
            <div className="col-sm-5 left-col">
              <ButtonGroup aria-label="Basic example">
                <Button variant="primary" className="pagi-btn" onClick={() => gotoPage(0)} disabled={!canPreviousPage}><i className="fa fa-angle-double-left"></i></Button>
                <Button variant="primary" className="pagi-btn" onClick={() => previousPage()} disabled={!canPreviousPage}><i className="fa fa-angle-left"></i></Button>
                <Button variant="primary" className="pagi-btn" onClick={() => nextPage()} disabled={!canNextPage}><i className="fa fa-angle-right"></i></Button>
                <Button variant="primary" className="pagi-btn" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><i className="fa fa-angle-double-right"></i></Button>
              </ButtonGroup>
              &nbsp;
              <span>
                Page{' '}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>{' '}
              </span>
            </div>
            <div className="col-sm-4"></div>
            <div className="col-sm-3 right-col">
              <Form.Group className="mb-3" >
                <Form.Select as="select" className="textbox-back" value={pageSize}
                  onChange={e => {
                    setPageSize(Number(e.target.value))
                  }}>
                  {[5, 10, 20, 30, 40, 50].map(pageSize => (
                    <option key={pageSize} value={pageSize}>
                      Show {pageSize} Rows
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
          </div>
  
        </>
      )
  
    }
export default memo(CreateDashboard)
